<template>
  <div>
    <div class="top-content col-xs-12 consumer-duty">
      <div class="summary-top-bar">
        <div class="right">
          <form @submit.prevent="onSearch">
            <input
                type="text"
                name="search"
                placeholder="Search"
                v-model="searchQuery"
            />
            <button type="submit" class="btn btn-secondary btn-search">Search</button>
          </form>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <table class="table table-responsive">
      <tbody>
      <tr v-for="(item, index) in items" :id="items[index].client_id">
        <td v-if="item.type === 'Person'">{{item.first_name + ' ' + item.last_name}}</td>
        <td v-else>{{item.business_name}}</td>
        <td>{{item.updated_at}}</td>
        <td class="text-right">
          <button type="button" class="btn btn-success" @click="syncDataClient(item.client_id); ">
            <i class="fa fa-refresh" :id="'button_icon_' + item.client_id"></i>
          </button>
          <button type="button" class="btn btn-success" @click="editDataClient(item); ">
            <i class="fa fa-edit" :id="'button_edit_icon_' + item.client_id"></i>
          </button>
          <button type="button" class="btn btn-success" @click="deleteDataClient(item); ">
            <i class="fa fa-trash" :id="'button_trash_icon_' + item.client_id"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <pagination :response="meta" @setPage="getDuplicateClients"></pagination>

    <vue-final-modal
        modal-id="update-client-data"
        class="modal--container modal-shadow"
        content-class="modal--content"
        :content-style="{
          width: '80vw',
          maxWidth: '1200px',
          maxHeight: '80vh',
          overflowY: 'auto',
          height: 'auto',
          padding: '20px',
        }"
        height="auto"
        @closed="resetFormClientData">
      <div class="update-client-data-modal-content">
        <intelliflo-office-client-form
            :client_id="currentClientId"
            :client_name="currentClientName"
            @data-updated="sentNewClientData"/>
      </div>
    </vue-final-modal>

  </div>
</template>

<script>
import { VueFinalModal, ModalsContainer } from 'vue-final-modal'
import IntellifloOfficeClientForm from "./IntellifloOfficeClientForm.vue";

export default {
  name: "IntellifloOfficeDuplicateClientsTable",
  components: {
    IntellifloOfficeClientForm,
    VueFinalModal,
    ModalsContainer,
  },
  props: {
    typeDuplicate: String
  },
  data() {
    return {
      items: {
        missing_data_columns: [], //
      },
      meta: {},
      page: null,
      thisPage: null,
      searchQuery: '',
      currentClientId: null,
      currentClientName: null,
    }
  },
  methods: {
    onSearch() {
      this.getDuplicateClients(1, this.searchQuery);
    },
    getDuplicateClients(page = 1, search = '') {
      this.thisPage = page;
      const typeDuplicate = this.typeDuplicate ? '/' + this.typeDuplicate : '';
      axios.get(`/io/duplicate-clients${typeDuplicate}?page=${page}`, {
        params: { page, search },
      }).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    syncDataClient(clientId) {
      this.inProcess(clientId, true)
      axios.get(`/io/syncdata-client/${clientId}`).then((res) => {
        this.markUpdateStatus(clientId, res.data.update_status);
        this.inProcess(clientId, false);
        setTimeout(() => {
          const row = document.getElementById(clientId);
          row.classList.remove(res.data.update_status);
          this.getDuplicateClients(this.thisPage);
        }, 2000);
      }).catch((error) => {
        console.log('error', error)
        this.inProcess(clientId, false)
      })
    },
    editDataClient(item) {
      this.currentClientId = item.client_id;
      this.currentClientName = item.first_name + ' ' + item.last_name;
      this.$vfm.open("update-client-data");
    },
    resetFormClientData() {
      this.currentClientId = null;
      this.currentClientName = null;
    },
    sentNewClientData(data) {
      this.$vfm.close('update-client-data');
      this.syncDataClient(data.client_id);
      this.resetFormClientData()
    },
    inProcess(clientId, process) {
      const icon = document.getElementById('button_icon_' + clientId);
      if (process) {
        icon.classList.add("fa-spin");
      } else {
        icon.classList.remove("fa-spin");
      }
    },
    markUpdateStatus(clientId, className) {
      const row = document.getElementById(clientId);
      row.classList.add(className);
    },
    deleteDataClient(item) {
      if (confirm(`Are you sure you want to delete client "${item.first_name} ${item.last_name}"?`)) {
        axios.delete(`/io/client-data/${item.client_id}/delete`).then((res) => {
          this.getDuplicateClients();
        }).catch((error) => {
          console.log('error', error)
        })
      }
    }
  },
  created() {
    this.getDuplicateClients();
  }
}
</script>

<style scoped>
:not(.input-group-btn) > .btn:not(.btn-search) {
  padding: 8px 0;
  border-radius: 0;
  margin: 2px;
  background-color: #73C2AF;
}
.btn-search {
  margin-left: 10px;
}
</style>